import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { parseMarginOrPadding } from '@helpers'
import Link from '@atoms/link'
import { Defaults } from '@styles/theme'

const propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  className: PropTypes.string,
  link: PropTypes.string,
  href: PropTypes.string
}

const ButtonComponent = ({
  children,
  onClick,
  className,
  link,
  href,
  ...rest
}) => {
  if (link || href) {
    return (
      <Link className={className} {...rest} to={link} href={href}>
        {children}
      </Link>
    )
  } else {
    return (
      <button className={className} onClick={onClick} {...rest}>
        {children}
      </button>
    )
  }
}

const Button = styled(ButtonComponent)`
  display: flex;
  justify-content: center;
  align-items: center;

  /* Text */
  font-size: ${(props) =>
    props.size || props.theme.typography.button.fontSize}rem;
  font-family: ${(props) => props.theme.typography.button.fontFamily};
  font-weight: ${(props) => props.theme.typography.button.fontWeight};
  letter-spacing: ${(props) => props.theme.typography.button.spacing}em;

  background: ${(props) =>
    props.secondary ? 'transparent' : props.theme.colors.primary};
  color: ${(props) =>
    props.secondary
      ? props.theme.colors.primary
      : props.theme.colors.onPrimary};

  border: ${(props) => (props.secondary ? '3px solid #00805D;' : 'none')};
  outline: none;

  cursor: pointer;

  margin: ${({ margin }) => parseMarginOrPadding(margin)};
  padding: ${({ padding }) =>
    parseMarginOrPadding(padding, '0.75em 1.5em 0.75em 1.5em')};

  box-sizing: border-box;

  border-radius: ${Defaults.borderRadius};

  text-decoration: none;

  transition: background 150ms ease-out, border-color 150ms ease-out,
    color 150ms ease-out;
  :hover {
    background: ${(props) =>
      props.secondary ? 'transparent' : props.theme.palette.primary['500']};
    border-color: ${(props) =>
      props.secondary ? props.theme.palette.primary['500'] : 'none'};
    color: ${(props) =>
      props.secondary ? props.theme.palette.primary['500'] : 'white'};
  }
  :active {
    background: ${(props) =>
      props.secondary ? 'transparent' : props.theme.palette.primary['600']};
    border-color: ${(props) =>
      props.secondary ? props.theme.palette.primary['600'] : 'none'};
    color: ${(props) =>
      props.secondary ? props.theme.palette.primary['600'] : ''};
  }
`

ButtonComponent.propTypes = propTypes
export default Button
